export default __webpack_public_path__ + "static/media/play.f902960a.png";